import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { globals } from "../../globals";
import { Observable } from "rxjs";
import { IGridifyQuery } from "gridify-client";
import { QueryFilterService } from "./query-filter-service";
import { AnaliseCreditoModel } from "src/app/dominio/analise-credito-model";
import { PaginatedModel } from "src/app/dominio/paginated-model";
import { TipoSituacaoCadastral } from "../../dominio/enums";

export class DetalharAnaliseCreditoResponse {
  result: AnaliseCreditoModel;
}

export class ListarAnaliseCreditoResponse {
  results: AnaliseCreditoModel[];
  pagination: PaginatedModel
}

export class CadastrarAnaliseCreditoRequest {
  nome: string;
  descricao: string | undefined;
  situacao: TipoSituacaoCadastral;
  validadeTipo: string | undefined;
  validadeMeses: number | undefined;
}

export class AtualizarAnaliseCreditoRequest {
  nome: string;
  descricao: string | undefined;
  situacao: TipoSituacaoCadastral;
  validadeTipo: string | undefined;
  validadeMeses: number | undefined;
}

@Injectable({
  providedIn: 'root'
})
export class AnaliseCreditoService {
  constructor(
    private http: HttpClient,
    private queryFilterService: QueryFilterService
  ) {

  }

  detalhar(id: number): Observable<DetalharAnaliseCreditoResponse> {
    return this.http.get<DetalharAnaliseCreditoResponse>(`${globals.apiUrl}/api/v2/core/config/analise-credito/${id}`);
  }

  listar(queryFilter: IGridifyQuery | null = null): Observable<ListarAnaliseCreditoResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<ListarAnaliseCreditoResponse>(`${globals.apiUrl}/api/v2/core/config/analise-credito`, { params });
  }

  cadastrar(data: CadastrarAnaliseCreditoRequest): Observable<DetalharAnaliseCreditoResponse>{
    return this.http.post<DetalharAnaliseCreditoResponse>(
      `${globals.apiUrl}/api/v2/core/config/analise-credito`,
      data
    );
  }

  atualizar(id: number, data: AtualizarAnaliseCreditoRequest): Observable<DetalharAnaliseCreditoResponse>{
    return this.http.put<DetalharAnaliseCreditoResponse>(
      `${globals.apiUrl}/api/v2/core/config/analise-credito/${id}`,
      data
    );
  }

  excluir(id: number): Observable<void>{
    return this.http.delete<void>(
      `${globals.apiUrl}/api/v2/core/config/analise-credito/${id}`
    );
  }
}
